export const ACCREDITATIONS_PERMISSION_MODULE = 'accreditations'
export const NOTIFICATIONS_PERMISSIONS_MODULE = 'notifications'
export const EXPORTS_PERMISSION_MODULE = 'exports'
export const SETTINGS_PERMISSION_MODULE = 'settings'
export const ACCESS_PERMISSION_MODULE = 'access'
export const TRACKING_PERMISSION_MODULE = 'tracking'
export const SURGICAL_LOGS_PERMISSION_MODULE = 'logging'
export const DOCUMENTS_PERMISSION_MODULE = 'documents'
export const LISTS_PERMISSIONS_MODULE = 'lists'
export const REPORTS_PERMISSION_MODULE = 'reports'
export const QA_PERMISSIONS_MODULE = 'qa'
export const CLINICS_PERMISSIONS_MODULE = 'clinics'
export const DEVICES_PERMISSIONS_MODULE = 'devices'
export const USERS_PERMISSIONS_MODULE = 'users'
export const AUDITS_PERMISSION_MODULE = 'audits'
